var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h2 class="CDB-Text CDB-Size-small is-semibold u-upperCase u-errorTextColor">Sorry, something went wrong.</h2>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/ui/legends/base/error-title.tpl
// module id = 1964
// module chunks = 6